import React, {useContext} from 'react';

import CommentEscalation from '~/src/components/comment/escalation/CommentEscalation';
import CommentInput from '~/src/components/comment/input/CommentInput';
import CommentReaction from '~/src/components/comment/reaction/CommentReaction';

import {isEnabled} from '~/src/utilities/helpers/feature';
import {Feature} from '~/src/utilities/constants/feature';
import {utcToFormat} from '~/src/utilities/helpers/date';
import {classNames} from '~/src/utilities/helpers/css';
import {SettingsContext} from '~/src/components/context/SettingsContext';

import css from './CommentCard.module.scss';

const dateFormat = 'DD.MM.YYYY, HH:mm';

const renderReplies = (replies, siteArea, assetId, id, commentingEnabled) => {
    const subCardClasses = classNames(css, 'commentCard', 'subComment', siteArea);

    return replies.map((element, index) => {
        const replyDate = utcToFormat(element.createdAt, dateFormat);
        return (
            <article className={subCardClasses} key={`subcomment_${index}`} data-testid="SubCommentCard">
                <header className={css.header}>
                    <div className={css.headerRight}>
                        <h1 className={css.authorNickname}>{element.authorNickname}</h1>
                        <h2 className={css.createdAt}>{replyDate}</h2>
                    </div>
                </header>

                <p className={css.body}>{element.body}</p>

                <div className={css.commentActionsContainer}>
                    <CommentReaction commentId={element.id} reactions={element.reactions} />
                    <CommentEscalation id={element.id} />
                    {commentingEnabled && <CommentInput id={assetId} parentId={id} isReply={true} replyToNickname={element.authorNickname} />}
                </div>
            </article>
        );
    });
};

const CommentCard = ({assetId, authorNickname, createdAt, body, id, reactions, commentingEnabled, replies, page}) => {
    const {siteArea} = useContext(SettingsContext);
    const commentDate = utcToFormat(createdAt, dateFormat);
    const cardClasses = classNames(css, 'commentCard', siteArea);

    return (
        <article className={cardClasses} data-testid="CommentCard">
            <header className={css.header}>
                <div className={css.headerRight}>
                    <h1 className={css.authorNickname}>{authorNickname}</h1>
                    <h2 className={css.createdAt}>{commentDate}</h2>
                </div>
            </header>

            <p className={css.body}>{body}</p>

            <div className={css.commentActionsContainer}>
                <CommentReaction commentId={id} reactions={reactions} />
                <CommentEscalation id={id} />
                {isEnabled(Feature.REPLY_COMMENTS) && (
                    <React.Fragment>
                        {commentingEnabled && <CommentInput id={assetId} parentId={id} isReply={true} replyToNickname={authorNickname} />}
                        {replies && page === 'CommentPage' && renderReplies(replies, siteArea, assetId, id, commentingEnabled)}
                    </React.Fragment>
                )}
            </div>
        </article>
    );
};

export default CommentCard;
